<template>
    <el-container class="mainPage">
        <el-header>
            <div class="midBlock">
                <!-- <img src="/static/images/utils/logow_1.png" class="marLogo"> -->
                <div class="marSysTit">{{ sysName }}</div>

                <el-dropdown @command="rightDropdown" trigger="click">
                    <span class="el-dropdown-link">
                        {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="mine">个人信息</el-dropdown-item>
                        <el-dropdown-item command="logout">{{$t('login.logout')}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!-- <i class="el-icon-message-solid topFunIcon" @click="showMsgBox">
                    <span id="unReadIcon" v-if="unReadCount">{{unReadCount}}</span>
                </i> -->
            </div>
        </el-header>
        <el-container class="rightContainer">
            <el-aside :width="isCollapse?'64px':'200px'">
                <!-- 3bb4d4 8c335a -->
                <el-scrollbar style="height: calc(100% - 0px); z-index: 10; margin-top: 0px; background-size: cover; background-image: url('/static/images/pic/bg1.jpg');">
                    <!-- background-image: linear-gradient(to bottom, #077cf5, #2c335a); -->
                    <el-menu class="" @open="handleOpen" @close="handleClose" :unique-opened="true" :collapse="isCollapse">
                        <template v-for="(item) in menuAll" :index='item.id.toString()'>
                            <el-menu-item v-if="item.url" :key="item.id" :index='item.id.toString()' @click="addTab(item.url, item.name)" class="selectNone">
                                <div class="dots">
                                    <i :class="'iconfont'" v-html="item.icon?item.icon:'&#xe7cc;'"></i>
                                    <span :title="item.name">{{item.name}}</span>
                                </div>
                            </el-menu-item>
                            <el-submenu v-else :key="item.id" :index="item.id.toString()" class="selectNone">
                                <template slot="title">
                                    <div class="dots">
                                        <i :class="'iconfont'" v-html="item.icon?item.icon:'&#xe7cc;'"></i>
                                        <span :title="item.name">{{item.name}}</span>
                                    </div>
                                </template>

                                <template v-for="(child) in item.children" :index='child.id.toString()'>
                                    <el-menu-item v-if="child.url" :key="child.id" :index='child.id.toString()' @click="addTab(child.url, child.name)" class="selectNone menuLev2">{{child.name}}
                                    </el-menu-item>

                                    <el-submenu v-else :key="child.id" :index="child.id.toString()" class="selectNone">
                                        <template slot="title">
                                            <div class="dots" :title="child.name">{{child.name}}</div>
                                        </template>

                                        <template v-for="(child2) in child.children" :index='child2.id.toString()'>
                                            <el-menu-item :key="child2.id" :index='child2.id.toString()' @click="addTab(child2.url, child2.name)" class="selectNone menuLev2">{{child2.name}}
                                            </el-menu-item>
                                        </template>

                                    </el-submenu>
                                </template>

                            </el-submenu>
                        </template>
                    </el-menu>
                </el-scrollbar>
                <div class="colpBtn" @click="toggleCollapse" :style="'left:'+(isCollapse?'19px':'175px')+'; bottom:10px;'">
                    <i :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i>
                </div>
            </el-aside>
            <el-main>
                <el-row style="height: 100%;">
                    <el-col :span="24" style="height: 100%;">
                        <el-tabs id="mainTabs" v-model="currTabName" type="card" @tab-remove="removeTab" @tab-click="clickTab" style="height: 100%;">
                            <el-tab-pane v-for="(item) in tabArr" :key="item.name" :label="item.title" :name="item.name" :closable="item.closable">
                                <span slot="label">
                                    <span class="span-box">
                                        <i :class="'iconfont topBarIcon'" v-html="item.icon?item.icon:'&#xe7cc;'"></i>
                                        <span>{{item.title }}</span>
                                    </span>
                                </span>

                                <keep-alive>
                                    <tab-component :is="item.content" :key="item.ts" @addTab="addTab" @closeTab="closeTab" @refreshTab="refreshTab" @exportTaskStart="onExportTaskStart" :curr="currTabName==item.name" :param="item.param"></tab-component>
                                </keep-alive>
                            </el-tab-pane>
                        </el-tabs>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>

        <el-dialog :title="centerDialogTit" :width="centerDialogWidth" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="true" :visible.sync="centerDialogVisible" v-if="centerDialogVisible" append-to-body>
            <component :is="centerComp.con" :key="centerComp.ts" :param="centerComp.param" @closeCallback="centerDialogVisible=false" @confirmCallback="centerConfirmCallback"></component>
        </el-dialog>

        <el-drawer :title="hcComp.title" :visible.sync="hcVisible" :size="hcComp.size" :with-header="false" append-to-body>
            <component :is="hcComp.con" :key="hcComp.ts" :param="hcComp.param" @closeCallback="hcVisible=false" @comCallback="comCallback"></component>
        </el-drawer>

        <div class="exportTaskFloat" v-show="exportTasks.length > 0" @click="exportTaskPanelVisible = !exportTaskPanelVisible">
            <el-badge :value="activeTaskCount" :hidden="activeTaskCount === 0" class="exportTaskBadge">
                <i class="el-icon-download exportTaskIcon"></i>
            </el-badge>
            <span class="exportTaskLabel">导出</span>
        </div>

        <div class="exportTaskPanel" v-show="exportTaskPanelVisible && exportTasks.length > 0">
            <div class="exportTaskPanelHeader">
                <span>导出任务</span>
                <i class="el-icon-close" @click="exportTaskPanelVisible = false"></i>
            </div>
            <div class="exportTaskPanelBody">
                <div v-for="task in exportTasks" :key="task.taskId" class="exportTaskItem">
                    <div class="taskStatusRow">
                        <span :class="'taskStatus taskStatus' + task.status">{{ task.statusFmt }}</span>
                        <span class="taskTime">{{ task.createTime }}</span>
                    </div>
                    <el-progress v-if="task.status === 0 || task.status === 1" :percentage="task.total ? Math.round(task.done / task.total * 100) : 0" :format="() => task.done + '/' + task.total" :stroke-width="16" class="taskProgress"></el-progress>
                    <div v-if="task.status === 0 || task.status === 1" class="taskCancelRow">
                        <el-button size="mini" type="text" :disabled="task.cancelled" @click.stop="cancelExportTask(task)">{{ task.cancelled ? '正在取消…' : '取消' }}</el-button>
                    </div>
                    <div v-if="task.status === 2" class="taskDoneRow">
                        <span class="taskDoneInfo">{{ task.done }}/{{ task.total }} 已完成</span>
                        <el-button type="primary" size="mini" icon="el-icon-download" @click.stop="downloadExportZip(task)">下载</el-button>
                    </div>
                    <div v-if="task.status === 3" class="taskFailed">
                        <i class="el-icon-warning"></i>
                        <span>{{ task.message || '导出失败，请重新发起' }}</span>
                    </div>
                    <div v-if="task.status === 4" class="taskCancelled">
                        <i class="el-icon-circle-close"></i>
                        <span>已取消</span>
                    </div>
                    <div v-if="task.message && task.status !== 3" class="taskMsg">{{ task.message }}</div>
                </div>
            </div>
        </div>

    </el-container>
</template>

<script>
export default {
    name: "index",
    components: {},
    data () {
        return {
            sysName: config.sysName,
            circleUrl: "",
            menuAll: [],
            menuBase: [],
            menuTopIndex: 0, // 选中的顶部菜单
            homePath: '/dashboard', // /dashboard
            currTabName: '',
            tabArr: [],
            userNo: '',
            userName: '',
            entName: '',
            phone: '',
            isCollapse: false,
            unReadCount: 0,

            hcComp: {},
            hcVisible: false,

            centerDialogTit: '',
            centerDialogVisible: false,
            centerComp: {},
            centerDialogWidth: '50%',

            exportTasks: [],
            pollingTimer: null,
            exportTaskPanelVisible: false,
        };
    },
    computed: {
        activeTaskCount: function () {
            return this.exportTasks.filter(function (t) { return t.status === 0 || t.status === 1; }).length;
        },
    },
    methods: {
        handleOpen (key, keyPath) {
            // console.log(key, keyPath);
        },
        handleClose (key, keyPath) {
            // console.log(key, keyPath);
        },
        refreshTab: function (path) {
            let _this = this;
            if (path.indexOf("?") != -1) {
                let n = path.indexOf("?");
                path = path.substring(0, n);
            }

            let name = path.replaceAll('/', '');
            this.tabArr.forEach((tab, index) => {
                if (tab.name === name) {
                    _this.$set(_this.tabArr[index], "ts", new Date().getTime());
                }
            });
        },
        clearTab: function () {
            // 关闭首页以外的其他tab
            let _this = this;
            this.tabArr.forEach((tab, index) => {
                if (tab.name != 'dashboard') {
                    _this.removeTab(tab.name);
                }
            });
        },
        addTab (path, title, param, self) {
            if (!path) {
                this.$message({
                    showClose: true,
                    message: this.$t('menu.unConfig'),
                    type: 'warning'
                })
                return;
            }
            if (self == undefined) {
                self = false;
            }

            if (path.indexOf("?") != -1) {
                if (!param) {
                    param = {};
                }
                // 解析参数
                let n = path.indexOf("?");
                let paramStr = path.substr(n + 1);
                let paramArr = paramStr.split("&");
                paramArr.forEach(function (nn, i) {
                    let arr = nn.split("=");
                    param[arr[0]] = arr[1];
                });

                path = path.substring(0, n);
            }


            let name = path.replaceAll('/', '');
            let pagePath = path;

            var comp = () => import('@/components' + pagePath + '.vue');
            if (!param) {
                param = {};
            }
            param.tabName = name;

            // TODO 拦截器此处进行判断权限

            // 是否已经打过该标签
            let has = false;
            let _this = this;
            this.tabArr.forEach((tab, index) => {
                if (tab.name === name || (self && _this.currTabName === tab.name)) {
                    has = true;
                    if (self) {
                        _this.$set(_this.tabArr[index], "param", param);
                        _this.$set(_this.tabArr[index], "content", comp);
                        _this.$set(_this.tabArr[index], "ts", new Date().getTime());
                    } else {
                        // 组件的key元素，如果变化，组件会从新渲染
                        _this.$set(_this.tabArr[index], "title", title);
                        _this.$set(_this.tabArr[index], "param", param);
                        _this.$set(_this.tabArr[index], "content", comp);
                        _this.$set(_this.tabArr[index], "ts", new Date().getTime());
                    }
                }
            });

            if (!has) {
                let icon = '';
                this.menuAll.forEach(function (n, i) {
                    if (n.children) {
                        n.children.forEach(function (nn, ii) {
                            if (nn.url == path) {
                                icon = nn.icon;
                            }
                            if (nn.children && nn.children.length > 0) {
                                nn.children.forEach(function (nnn, iii) {
                                    if (nnn.url == path) {
                                        icon = nnn.icon;
                                    }
                                });
                            }
                        });
                    }
                });

                if (!icon) {
                    // 特殊处理一些没有在sys_menu里配置的路径的icon
                    let iconObj = {
                        "/dashboard": "&#xe751;",
                    };
                    if (iconObj[path]) {
                        icon = iconObj[path];
                    }
                }

                this.tabArr.push({
                    title: title,
                    name: name,
                    icon: icon,
                    param: param,
                    content: comp,
                    closable: path == this.homePath ? false : true
                });
                // console.log(name + '----' + icon);
            }
            if (!self) {
                this.currTabName = name;
            }
        },
        removeTab (targetName) {
            // console.log('delete tab  :', targetName);
            let tabs = this.tabArr;
            let active = this.currTabName;
            if (active === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            active = nextTab.name;
                        }
                    }
                });
            }

            this.currTabName = active;
            this.tabArr = tabs.filter(tab => tab.name !== targetName);
        },
        clickTab: function (e) {
            // console.log(e);
        },
        closeTab: function (path) {
            let targetName = this.currTabName;
            if (path) {
                targetName = path.replaceAll('/', '');
            }
            this.removeTab(targetName);
        },

        rightDropdown: function (command) {
            if (command == 'logout') {
                sessionStorage.removeItem("hwt-token");
                sessionStorage.removeItem("uid");
                sessionStorage.removeItem("userName");
                sessionStorage.removeItem("avatar");
                sessionStorage.removeItem("menuArr");
                sessionStorage.removeItem("funsArr");
                sessionStorage.removeItem("orgId");

                this.$router.push("/login");
            } else if (command == 'mine') {
                this.centerComp = {
                    con: () => import('@/components/sys/user_info_edit.vue'),
                    ts: new Date().getTime(),
                    param: {},
                };
                this.centerDialogTit = '个人信息';
                this.centerDialogWidth = '500px';
                this.centerDialogVisible = true;
            }
        },
        centerConfirmCallback: function (param) {
            this.centerDialogVisible = false;
            if (param.code && param.code == 'user_info_update') {
                this.userName = sessionStorage.getItem("userName");
                this.refreshTab('/dashboard');
            }
        },

        toggleCollapse: function () {
            this.isCollapse = !this.isCollapse;

            setTimeout(function () {
                var myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            }, 100);
        },
        resize: function () {
            let h = document.body.clientHeight;
            let w = document.body.clientWidth;
        },
        showMsgBox: function () {
            // this.$message.success('暂无消息');
            // this.hcComp = {
            //     con: () => import('@/components/sys/msg_comp.vue'),
            //     ts: new Date().getTime(),
            //     param: {},
            //     size: '50%',
            //     title: '消息通知',
            // };
            // this.hcVisible = true;
        },
        comCallback: function (param) {
            if (param.fun == 'reloadUnReadCount') {
            }
        },
        onExportTaskStart: function () {
            this.exportTaskPanelVisible = true;
            this.loadExportTasks();
        },
        loadExportTasks: function () {
            var _this = this;
            this.req('/pap_asmt_export_task_my', {}, function (data) {
                if (data.success) {
                    _this.exportTasks = data.obj || [];
                    _this.startOrStopPolling();
                }
            }, 'get', false);
        },
        startOrStopPolling: function () {
            var hasActive = this.exportTasks.some(function (t) { return t.status === 0 || t.status === 1; });
            if (hasActive && !this.pollingTimer) {
                this.pollingTimer = setInterval(this.loadExportTasks.bind(this), 5000);
            } else if (!hasActive && this.pollingTimer) {
                clearInterval(this.pollingTimer);
                this.pollingTimer = null;
            }
        },
        downloadExportZip: function (task) {
            if (task.status !== 2) {
                this.$message.warning('任务未完成，暂时无法下载');
                return;
            }
            var token = sessionStorage.getItem("hwt-token");
            var base = process.env.NODE_ENV === "development" ? config.apiHost : "/api";
            var url = base + '/pap_asmt_export_task_download?taskId=' + task.taskId + '&token=' + token;
            window.location.href = url;
        },
        cancelExportTask: function (task) {
            var _this = this;
            this.req('/pap_asmt_export_task_cancel?taskId=' + task.taskId, {}, function (data) {
                if (data.success) {
                    if (task.status === 0) {
                        _this.$message.success('任务已取消');
                    } else {
                        _this.$message.success('取消请求已提交，正在停止导出…');
                    }
                    _this.loadExportTasks();
                }
            }, 'post', true);
        },
        // loadSysName: function () {
        //     let _this = this;
        //     this.req('/common/qry_sys_param?type=SYS_PARAM_SYS_NAME&mult=false', {}, function (data) {
        //         if (data.success) {
        //             _this.sysName = data.obj.value;
        //         }
        //     }, 'get')
        // },
    },
    mounted: function () {

        this.$nextTick(function () {
            let _this = this;
            this.uid = sessionStorage.getItem("uid");
            this.userName = sessionStorage.getItem("userName");
            let menus = JSON.parse(sessionStorage.getItem("menuArr"));

            this.menuAll = menus;

            this.resize();
            window.addEventListener('resize', () => {
                this.resize();
            });
            // this.loadSysName();

            this.addTab('/dashboard', this.$t('tabName.dashboard'));

            let date = this.lib.timeFormat(new Date(), 'yyyy-mm-dd');
            this.$watermark.set(this.uid + "/" + this.userName + ' ' + date)

            this.loadExportTasks();

        });
    },
    beforeDestroy: function () {
        this.$watermark.remove();
        if (this.pollingTimer) {
            clearInterval(this.pollingTimer);
        }
    },
};
</script>
<style scoped>
.marLogo {
    height: 40px;
    display: block;
    float: left;
    margin-top: 10px;
    margin-right: 10px;
}
.marSysTit {
    color: #000;
    font-size: 28px;
    line-height: 60px;
    width: auto;
    float: left;
}
.el-container {
    height: 100%;
}
.el-header {
    background-color: #f1f8ff;
    background-image: url("/static/images/utils/topbg.png");
    background-size: contain;
    background-position: 90% 0px;
    background-repeat: no-repeat;
    color: #fff;
    text-align: center;
    line-height: 60px;
    padding: 0;
    border-bottom: 1px solid #e5e5e5;
}

.rightContainer {
    /* width: calc(100% - 200px); */
    width: 100%;
    height: calc(100% - 60px);
}

.midBlock {
    height: 60px;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    position: relative;
}

.el-aside {
    color: #333;
    height: 100%;
    background-size: cover;
    background-position: 50%;
    overflow: hidden;
}

.el-aside >>> .el-submenu [class^="el-icon-"] {
    margin-right: 0px;
}

.el-aside >>> .el-menu-item [class^="el-icon-"] {
    margin-right: 0px;
}

.el-aside >>> .el-submenu__title i {
    font-size: 18px;
    font-weight: 400;
    color: #000;
}
.el-aside >>> .el-submenu__title {
    color: #000;
}
.el-aside >>> .el-submenu__title span {
    padding-left: 0px;
}
.el-aside >>> .el-submenu__title:focus,
.el-aside >>> .el-submenu__title:hover {
    background-color: #409EFF33;
}
.el-aside >>> .el-menu-item i {
    font-size: 18px;
    font-weight: 400;
    color: #000;
}
.el-aside >>> .el-menu-item span {
    padding-left: 3px;
    color: #000;
}

.el-aside >>> .el-menu-item:focus,
.el-aside >>> .el-menu-item:hover {
    background-color: #409EFF33;
}

.menuLev2 {
    color: #000;
}
.el-menu--vertical .menuLev2 {
    background-color: #fff;
    color: #333;
}
.el-menu--vertical .menuLev2:hover {
    background-color: #e5e5e5;
}

.el-main {
    color: #333;
    height: 100%;
    /* background: url("/static/images/utils/elMainBk.png") repeat; */
    /* border-radius: 4px; */
    /* background-color: #f7f7f8; */
    /* background-image: url('/static/images/utils/topbk1.png');
    background-repeat: repeat-x; */
    background-color: #f2f3f5;
    /* background: linear-gradient(to top, #eee 85%, #a0c2a1 15%); */

    padding-right: 0px;
}

body > .el-container {
    margin-bottom: 40px;
}

#mainTabs >>> .el-tabs__content {
    height: calc(100% - 40px);
    overflow-y: auto;
    padding-right: 20px;
}

.el-aside >>> .el-scrollbar__wrap {
    overflow-x: hidden;
}

.el-header >>> .el-scrollbar__wrap {
    overflow-x: hidden;
}

.el-header >>> .el-scrollbar__wrap .el-scrollbar__view {
    white-space: nowrap;
}
.el-dropdown-menu {
    top: 60px !important;
}

/* */
.el-dropdown {
    float: right;
}
.el-dropdown-link {
    cursor: pointer;
    color: #000;
    font-size: 16px;
}
.el-icon-arrow-down {
    font-size: 12px;
    color: #000;
}

/** */
.alertTip {
    float: right;
    margin-right: 30px;
    line-height: 30px;
    margin-top: 15px;
    font-size: 16px;
    padding-right: 10px;
}

/** */
.searchInput {
    float: right;
    margin-right: 30px;
    width: 220px;
    box-sizing: border-box;
    /* margin-top: 10px; */
}
/* .searchInput .el-input-group__prepend {
    background-color: #fff;
}
.searchInput /deep/ .el-input__inner:focus {
    border-color: #dcdfe6;
} */

.handIcon {
    cursor: pointer;
    user-select: none;
}
.paginationDiv {
    margin-top: 20px;
}

.colpBtn {
    width: 25px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: absolute;
    z-index: 50;
    bottom: 0px;
    left: 0px;
    /* background-color: #f2f3f5;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px; */
    cursor: pointer;
    box-sizing: border-box;
}
.colpBtn i {
    font-size: 20px;
    line-height: 50px;
    color: #000;
}

.alertDialog /deep/ .el-tabs__item {
    margin-right: 0px;
}
.saLine {
    text-align: left;
}

.sadt {
    font-weight: bold;
}

.topBarIcon {
    color: #666;
    font-size: 16px;
}
.is-active .topBarIcon {
    color: #077cf5;
}

.topFunIcon {
    display: block;
    float: right;
    width: 30px;
    line-height: 60px;
    text-align: center;
    font-size: 22px;
    margin-right: 10px;
    cursor: pointer;
    position: relative;
}

#unReadIcon {
    font-size: 11px;
    height: 18px;
    line-height: 18px;
    min-width: 18px;
    display: block;
    position: absolute;
    /* z-index: 9; */
    right: -5px;
    top: 10px;
    background-color: #f56c6c;
    color: #fff;
    border-radius: 18px;
}

.expSysItem {
    display: flex;
    justify-content: center; /* 垂直居中 */
    margin-bottom: 20px;
    padding: 10px 10px;
    gap: 10px;
}
.expIcon {
    color: #077cf5;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 28px;
}
.expName {
    flex: 1;
    line-height: 40px;
    font-size: 18px;
}
.expRowSel {
    background-color: #077cf522;
    border-radius: 4px;
}

.exportTaskFloat {
    position: fixed;
    right: 20px;
    bottom: 60px;
    width: 56px;
    height: 56px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2000;
    transition: box-shadow 0.3s;
}
.exportTaskFloat:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}
.exportTaskBadge {
    line-height: 1;
}
.exportTaskIcon {
    font-size: 24px;
    color: #409eff;
}
.exportTaskLabel {
    font-size: 10px;
    color: #666;
    margin-top: 2px;
}

.exportTaskPanel {
    position: fixed;
    right: 20px;
    bottom: 130px;
    width: 340px;
    max-height: 420px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    z-index: 2001;
    display: flex;
    flex-direction: column;
}
.exportTaskPanelHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #ebeef5;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}
.exportTaskPanelHeader .el-icon-close {
    cursor: pointer;
    font-size: 16px;
    color: #909399;
}
.exportTaskPanelHeader .el-icon-close:hover {
    color: #409eff;
}
.exportTaskPanelBody {
    flex: 1;
    overflow-y: auto;
    padding: 8px 0;
}
.exportTaskItem {
    padding: 10px 16px;
    border-bottom: 1px solid #f2f3f5;
}
.exportTaskItem:last-child {
    border-bottom: none;
}
.taskStatusRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}
.taskStatus {
    font-size: 13px;
    font-weight: 500;
}
.taskStatus0 {
    color: #909399;
}
.taskStatus1 {
    color: #409eff;
}
.taskStatus2 {
    color: #67c23a;
}
.taskStatus3 {
    color: #f56c6c;
}
.taskStatus4 {
    color: #909399;
}
.taskTime {
    font-size: 12px;
    color: #c0c4cc;
}
.taskProgress {
    margin-top: 4px;
    margin-bottom: 8px;
}
.taskDoneRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4px;
}
.taskDoneInfo {
    font-size: 13px;
    color: #67c23a;
}
.taskFailed {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #f56c6c;
    margin-top: 4px;
}
.taskCancelled {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #909399;
    margin-top: 4px;
}
.taskCancelRow {
    text-align: right;
}
.taskMsg {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue